/** @format */

import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import useQuery from "../../Shared/queryString";

/** @format */
const Pagination = ({ totalPage, basePath, search = null }) => {
  const navigate = useNavigate();
  const pageParam = useQuery.getParam("page");

  const pageSet = (pageCount) => {
    let page = "";
    page = search?.replace(new RegExp(/([(\?|\&)]+)page=([0-9]+)/, "g"), "");
    page += search?.length > 0 ? "&" : "";
    page += "page=" + pageCount;
    return page;
  };

  const pageCount = Math.max(0, Number(totalPage) || 0);
  const parsedPage = pageParam == null ? 1 : parseInt(pageParam, 10);
  const initialPage =
    pageCount > 0
      ? Math.min(Math.max(parsedPage, 1), pageCount) - 1
      : 0;

  if (pageCount < 1) {
    return null;
  }

  return (
    <div className='w-100 mt-4 d-flex'>
      <ReactPaginate
        breakLabel='...'
        nextLabel='بعدی'
        pageRangeDisplayed={5}
        pageCount={pageCount}
        previousLabel='قبلی'
        initialPage={initialPage}
        pageClassName='c-pointer'
        pageLinkClassName='page-link'
        activeLinkClassName='active-page'
        previousLinkClassName='page-link'
        nextLinkClassName='page-link'
        disabledLinkClassName='disable-page'
        onClick={(page) => {
          return navigate(
            page.event.target.href.replace(window.location.origin, "")
          );
        }}
        hrefBuilder={(page, pageCount, selected) =>
          page >= 1 && page <= pageCount ? `${basePath}?${pageSet(page)}` : "#"
        }
        containerClassName='d-flex flex-row align-items-center list-style-none justify-content-center w-100'
        renderOnZeroPageCount={null}
      />
    </div>
  );
};

export default Pagination;
